
// => Styling
import styles from './SwipeButton.module.css';

// => Icons
import { 
    IoChevronBack,
    IoChevronForward,
} from "react-icons/io5";


// ============
// Component
// ============
const SwipeButton = ({
    direction = 'left',
    onClick = () => {},
}) => {


    // RENDER
    // ---------
    return(
        <div className={styles.container} onClick={onClick}>
            {direction === 'left'
            ? <IoChevronBack />
            : <IoChevronForward />}
        </div>
    )
}


export default SwipeButton